<template>
  <!-- 下级用户 -->
  <div>
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-input
            v-model="formData.id"
            placeholder="要复制到的用户id"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="formData.child_user_type" placeholder="转移类型">
            <el-option :value="0" label="转移全部"></el-option>
            <el-option :value="2" label="转移老用户"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit">转移下级用户</el-button>
        </el-form-item>
        <el-form-item>
          <el-button class="pull-right" type="primary" @click="handleExport"
            >导出表单</el-button
          >
        </el-form-item>
        <el-form-item label="渠道时间段:">
          <el-date-picker
            v-model="query.start_time"
            type="datetime"
            placeholder="开始时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
          -
          <el-date-picker
            v-model="query.end_time"
            type="datetime"
            placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button class="pull-right" type="primary" @click="getData(1)"
            >搜索</el-button
          >
        </el-form-item>
      </el-form>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-select
            v-model="query.child_user_type"
            placeholder="用户类型"
            @change="getData(1)"
          >
            <el-option :value="0" label="全部"></el-option>
            <el-option :value="1" label="新人"></el-option>
            <el-option :value="2" label="老人"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <span style="font-size: 18px"
            >新人渠道费：{{ formData1.new_user_amount }}&nbsp;&nbsp;&nbsp;</span
          >
        </el-form-item>
        <el-form-item>
          <span style="font-size: 18px"
            >老人渠道费：{{ formData1.old_user_amount }}&nbsp;&nbsp;&nbsp;</span
          >
        </el-form-item>
        <el-form-item>
          <span style="font-size: 18px"
            >新人人数：{{ formData1.new_user_count }}&nbsp;&nbsp;&nbsp;</span
          >
        </el-form-item>
        <el-form-item>
          <span style="font-size: 18px"
            >老人人数：{{ formData1.old_user_count }}&nbsp;&nbsp;&nbsp;</span
          >
        </el-form-item>
      </el-form>
    </header>
    <el-table :data="dataList">
      <el-table-column prop="id" label="用户ID" width="120"></el-table-column>
      <el-table-column label="用户名称" width="200">
        <template slot-scope="scope">
          <div class="user-avatar">
            <img :src="scope.row.avatar || '/images/default-avatar.jpg'" alt />
            <span :style="{ color: getType(scope.row.child_user_type) }">{{
              scope.row.name
            }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注"> </el-table-column>
      <el-table-column prop="phone" label="电话号码">
        <template slot-scope="scope">{{
          scope.row.phone ? scope.row.phone : "-"
        }}</template>
      </el-table-column>
      <!-- <el-table-column prop="recharges" label="充值次数" width="100"></el-table-column>
      <el-table-column prop="withdrawals" label="提现次数" width="100"></el-table-column> -->
      <el-table-column prop="status" label="用户类型" width="100">
        <template slot-scope="{ row }">
          <el-tag v-if="row.type === 1" type="info">普通用户</el-tag>
          <el-tag v-if="row.type === 2" type="success">主播</el-tag>
          <el-tag v-if="row.type === 7" type="success">主播（新）</el-tag>
          <el-tag v-if="row.type === 4" type="warning">代理</el-tag>
          <el-tag v-if="row.type === 6" type="warning">试用期代理</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="账户状态" width="100">
        <template slot-scope="{ row }">
          <el-tag v-if="row.status === 1" type>正常</el-tag>
          <el-tag v-if="row.status === 2" type="info">冻结</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="recharge_amount"
        label="总充值"
        sortable
      ></el-table-column>
      <el-table-column
        prop="account_balance"
        label="余额"
        sortable
      ></el-table-column>
      <el-table-column
        prop="account_rebate"
        label="上级钻石返利"
      ></el-table-column>
      <el-table-column
        prop="anchor_rebate"
        label="上级渠道返利"
      ></el-table-column>
      <el-table-column prop="created_at" label="创建时间"></el-table-column>
      <el-table-column prop="bind_time" label="绑定时间"></el-table-column>
    </el-table>
    <!-- 底部分页条 -->
    <el-pagination
      background
      :page-size="dataMeta.per_page || 15"
      :total="dataMeta.total || 0"
      :current-page="dataMeta.current_page"
      @current-change="handlePageChange"
      v-if="dataMeta && dataMeta.total > dataMeta.per_page"
    ></el-pagination>
  </div>
</template>

<script>
import http, {
  patchData,
  getData,
  getApiData,
  server,
  postData
} from '../../http'
import saveFile from '../../utils/saveFile'
export default {
  props: {
    id: {
      type: String,
      default: undefined
    },
  },
  data() {
    return {
      query: {
        page: 1,
        start_time: '',
        end_time: '',
        child_user_type: 0, //0全部 1新人 2老人
      },
      formData: {
        id: "",
        child_user_type: 0, //0全部 1新人 2老人
      },
      formData1: {
        new_user_count: '',
        old_user_count: '',
        new_user_amount: '',
        old_user_amount: '',
      },
      dataList: undefined,
      dataMeta: undefined, //底部分页数据
    }
  },
  computed: {
    user_id() {
      return this.id
    }
  },
  watch: {},
  created() {
    this.getData(1)
  },
  methods: {
    getData(num) {
      if (num === 1) {
        this.query.page = 1
      }
      let params = this.query
      getData(`subordinate_user/${this.user_id}`, params).then((res) => {
        this.dataList = res.data
        this.formData1 = {
          new_user_count: res.new_user_count,
          old_user_count: res.old_user_count,
          new_user_amount: res.new_user_amount,
          old_user_amount: res.old_user_amount,
        }
        this.dataMeta = res
      })
    },
    submit() {
      //复制下级用户
      if (!this.formData.id) {
        this.$message.warning("请先输入用户id")
        return
      }
      let params = {
        user_id: this.formData.id,
        child_user_type: this.formData.child_user_type
      }
      postData(`subordinate_user_transfer/${this.id}`, params).then((res) => {
        if (res && res.code == 1) {
          this.$message.success(res.msg)
        }
      })
    },
    handleExport() {
      http
        .get(
          server + `user_lower_export/${this.id}`, {
          responseType: 'arraybuffer'
        }
        )
        .then(res => {
          saveFile(res, {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            name: '下级用户表单.xlsx'
          })
        })
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData();
    },
    getType(type) {
      switch (type) {
        case 2: return 'red';//红色 老人
        case 3: return 'blue';//蓝色 不返利用户
        case 4: return '#0fc70f';//绿色 有充值但未实名认证
      }
    }
  }
}

</script>

<style>
</style>
